<img class="search-icon" src="/assets/images/search.png"
     srcset="/assets/images/search.png 1x, /assets/images/search_2x.png 2x" (click)="openSearchDialog()">